import { history } from '@umijs/max';
import { message } from 'antd';

const loginPath = '/user/login';

// 防止重复提示401错误的标志
let isShowing401Error = false;

// 检查当前是否在登录页面
export const isLoginPage = () => {
  return window.location.pathname === loginPath || window.location.pathname.includes('/user/login');
};

// 处理401错误 - 统一的登录过期处理
export const handle401Error = () => {
  // 如果已在登录页面，不需要处理
  if (isLoginPage()) {
    return;
  }
  
  // 防止重复提示
  if (isShowing401Error) {
    return;
  }
  
  isShowing401Error = true;
  
  // 显示登录过期提示
  message.error('登录信息已过期，请重新登录！', 3);
  
  // 清除token和其他认证信息
  localStorage.removeItem('token');
  
  // 跳转到登录页面
  setTimeout(() => {
    history.push(loginPath);
    // 重置标志，允许下次提示
    setTimeout(() => {
      isShowing401Error = false;
    }, 1000);
  }, 1000);
};

// 清除认证信息
export const clearAuthInfo = () => {
  localStorage.removeItem('token');
};

// 检查是否有有效的token
export const hasValidToken = () => {
  return !!localStorage.getItem('token');
};
